import { defineStore } from 'pinia'
import type { FactureDTO } from '@/features/api/extranet/dto/Facture/FactureDTO'
import { shallowRef } from 'vue'
import * as services from '@/features/services/detail/facture/FactureService'

export const useFactureStore = defineStore('facture', () => {
  const model = shallowRef<FactureDTO>()

  async function loadData(code: string) {
    model.value = await services.loadFacture(code)
  }
  return {
    model,
    loadData
  }
})
